import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/toxicology/environmental-risk-assessment-era")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology/environmental-risk-assessment-era", statusCode: 301 }); },
});
